document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.js-community-2-track');
  const images = document.querySelectorAll('.js-community-2-image');

  if (!track || images.length === 0) return;

  const clones = 10;
  for (let i = 0; i < clones; i++) {
    images.forEach(image => {
      const clone = image.cloneNode(true);
      track.appendChild(clone);
    });
  }
});